import BaseService from './base'

export default class SecurityService extends BaseService {
  static resource() {
    return 'api/v1/external/securities'
  }
}
